import React, { Component } from 'react'
import { createBrowserHistory } from 'history'
import { Router, Route, Switch } from 'react-router-dom'

import indexRoutes from 'routes/index.jsx'
import ErrorPage from 'views/ErrorPage/ErrorPage'
import ReactGA from 'react-ga'

ReactGA.initialize('UA-122332148-1')
var hist = createBrowserHistory()

const withAnalytics = (WrappedComponent, options = {}) => {
    const trackPage = (page) => {
        ReactGA.set({
            page,
            ...options
        })
        ReactGA.pageview(page)
    }

    const Result = class Result extends Component{
        componentDidMount() {
            const page = this.props.location.pathname
            trackPage(page)
        }

        componentWillReceiveProps(nextProps) {
            const currentPage = this.props.location.pathname
            const nextPage = nextProps.location.pathname

            if (currentPage !== nextPage) {
                trackPage(nextPage)
            }
        }

        render() {
            return <WrappedComponent {...this.props} />
        }
    }

    return Result
}

const AnalyticsRouter = () => (
    <Router history={hist}>
        <Switch>
            {indexRoutes.map((prop, key) => {
                return <Route exact path={prop.path} key={key} component={withAnalytics(prop.component)} />
            })}

            <Route component={withAnalytics(ErrorPage)}> </Route>
        </Switch>
    </Router>
)

export default AnalyticsRouter


// WEBPACK FOOTER //
// ./src/AnalyticsRouter.js